import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { searchPlaces } from '@/lib/nominatim';

/** Place search (OSM Nominatim), enabled for queries of 3+ characters. */
export function usePlaceSearch(query: string) {
  const q = query.trim();
  return useQuery({
    queryKey: ['place-search', q],
    queryFn: ({ signal }) => searchPlaces(q, signal),
    enabled: q.length >= 3,
    staleTime: 5 * 60_000,
    placeholderData: keepPreviousData,
    retry: 1,
  });
}
